const findAndUpdateGrade = ({ currentGrades = [], updatedGrades }) =>
  currentGrades.map((currentGrade) => {
    const newGrade = updatedGrades.find(
      (updatedGrade) => updatedGrade.studentId === currentGrade.studentId
    );

    if (newGrade) {
      return { ...currentGrade, ...newGrade };
    }
    return currentGrade;
  });

export default findAndUpdateGrade;
